// Constants and Utils
import { toStringWithRoundUp } from "../../../common-utils/number-utils/NumberUtils";
import {
  formatText,
  toLocaleString,
} from "../../../common-utils/string-utils/StringUtils";
import {
  constructDateString,
  getDifferenceInDays,
} from "../../../common-utils/date-utils/DateUtils";
import { DATE_FORMATS } from "../../../constants/GeneralConstants";
import { ToohlLitStatusValues } from "../../constants/GeneralConstants";

// Components
import { MediaImage } from "../../../components/campaign-media-table-row/MediaRow";

// Page Components
export function RoadInfo({ road, roadType }) {
  return <td>{`${roadType}:${road.name}`}</td>;
}

export function MediaDurationCell({ campaignPlan }) {
  const { startTimestamp, endTimestamp } = campaignPlan || {};

  const diff = getDifferenceInDays(startTimestamp, endTimestamp) - 1;
  const dateString = constructDateString(
    startTimestamp,
    endTimestamp,
    DATE_FORMATS.full_month_with_date_year
  );
  return (
    <td className="align-top">
      <div className="text-right">
        {dateString}
        <span className="sub-text">{`${diff} days`}</span>
      </div>
    </td>
  );
}

export function MediaInfo({ media }) {
  const { title, type, width, height, litStatus, region } = media;
  const litStatusString = ToohlLitStatusValues[litStatus];

  return (
    <td>
      <div className="d-flex">
        <MediaImage media={media} />
        <div className="pl-2">
          <span>{title}</span>
          <span className="sub-text">
            {type} | {width}ft x {height}ft | {formatText(litStatusString)}
          </span>
          <span className="sub-text">{region}</span>
        </div>
      </div>
    </td>
  );
}

export function TgSpecificOts({
  estTgSpecific,
  liveTgSpecific,
  isShowLiveMetrics = false,
}) {
  const formattedEstTg = formatText(toStringWithRoundUp(estTgSpecific));
  const formattedLiveTg = formatText(toStringWithRoundUp(liveTgSpecific));

  return (
    <td className="align-top">
      <div className="text-right">
        {/* only est imp */}
        {!isShowLiveMetrics && <p className="mb-0">{formattedEstTg}</p>}

        {/* both live & est */}
        {isShowLiveMetrics && (
          <>
            <p className="mb-0">{formattedLiveTg}</p>
            <p className="mb-0 sub-text">{formattedEstTg}</p>
          </>
        )}
      </div>
    </td>
  );
}

export function GenericOts({
  estGeneric,
  liveGeneric,
  isShowLiveMetrics = false,
}) {
  const formattedEstGeneric = formatText(toStringWithRoundUp(estGeneric));
  const formattedLiveGeneric = formatText(toStringWithRoundUp(liveGeneric));

  return (
    <td className="align-top">
      <div className="text-right">
        {/* only est imp */}
        {!isShowLiveMetrics && <p className="mb-0">{formattedEstGeneric}</p>}

        {/* both live & est */}
        {isShowLiveMetrics && (
          <>
            <p className="mb-0">{formattedLiveGeneric}</p>
            <p className="mb-0 sub-text">{formattedEstGeneric}</p>
          </>
        )}
      </div>
    </td>
  );
}

export function TotalOts({ estTotal, liveTotal }) {
  return (
    <td>
      <div className="text-right">
        {toLocaleString(estTotal)}
        {liveTotal && (
          <span className="sub-text">{toLocaleString(liveTotal)}</span>
        )}
      </div>
    </td>
  );
}

export function Cost({ estCost, liveCost }) {
  return (
    <td>
      <div className="text-right">
        {estCost}
        {liveCost && (
          <span className="sub-text">{toStringWithRoundUp(liveCost)}</span>
        )}
      </div>
    </td>
  );
}
